import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router'

Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    count: 0,
    loadingCount: 0,
    loading: false,
    isLogin: false,
    user: {
      name: '',
      userName: '',
      id: null,
      token: ''
    },
    platform: ''
  },
  mutations: {
    increment(state) {
      state.count++
    },
    incrementLoading(state) {
      state.loadingCount++
      if (state.loadingCount > 0) { state.loading = true }
    },
    decrementLoading(state) {
      state.loadingCount--
      if (state.loadingCount <= 0) { state.loading = false }
    },
    logout(state, payload) {
      state.isLogin = false
      // 清理用户信息
      state.user.id = ''
      state.user.token = ''
      state.user.name = ''
      state.user.userName = ''
      // 跳转登录
      let matched = router.app.$route.matched;
      let query = Object.assign({}, router.app.$route.query);
      if (payload) {
        query.logout = payload.logout;
      }
      if (matched.length > 0) {
        router.push({ path: `${matched[0].path}/login`, query: query })
      }
    },
    loginIn(state, payload) {
      state.isLogin = true
      // 保存用户信息
      state.user.name = payload.name
      state.user.userName = payload.userName
      state.user.id = payload.id
      state.user.token = payload.token
      let matched = router.app.$route.matched;
      if (matched.length > 0) {
        let path = matched[0].path;
        path = path.substring(1)
        localStorage.setItem("token-" + path, payload.token)
      }
    },
    setPlatform(state, payload) {
      state.platform = payload.platform
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js